import type { ListBuilderList } from '../../../types';
import { createMerchandiserColumns } from '../columns';
import { MERCHANDISER_REQUIRED_FIELDS } from '../shared';

/**
 * Inactive Merchandisers list configuration
 * Shows inactive merchandiser locations
 */
export const inactiveMerchandisersList: ListBuilderList = {
	id: 'inactive-merchandisers',
	cacheTTL: 600000,
	name: 'Inactive Merchandisers',
	type: 'default',
	active: true,
	columns: createMerchandiserColumns(),
	description: 'Inactive merchandiser locations',
	defaultSortId: 'column-location-code-asc',
	filterRules: {
		locationType: {
			defaultValue: [{ id: 'merchandiser', label: 'Merchandiser' }],
		},
		locationStatus: {
			defaultValue: [{ id: 'inactive', label: 'Inactive' }],
		},
	},
	requiredFields: MERCHANDISER_REQUIRED_FIELDS,
	sortOrder: 1,
};
